import { render, staticRenderFns } from "./product-location.vue?vue&type=template&id=f629504e"
import script from "./product-location.vue?vue&type=script&lang=js"
export * from "./product-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports